// Copyright (c) 2018 Deere & Company

import PartRequestForm from '../state/part-request-form';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetForm = state =>
    PartRequestForm.update(state, {
        $set: getDefaultState().partRequestForm
    });

const updatePartRequestForm = (state, action) =>
    PartRequestForm.update(state, {
        $set: action.partRequestForm
    });

const updateComments = (state, action) =>
    PartRequestForm.update(state, {
        courierInfo: {
            comments: {
                $set: action.comments
            }
        }
    });

const updateCourierName = (state, action) =>
    PartRequestForm.update(state, {
        courierInfo: {
            courierName: {
                $set: action.courierName
            }
        }
    });

const updateDispatchDate = (state, action) =>
    PartRequestForm.update(state, {
        dispatchDate: {
            $set: action.dispatchDate
        }
    });

const updateReturnStatus = (state, action) =>
    PartRequestForm.update(state, {
        returnStatus: {
            $set: action.returnStatus
        }
    });

const updateTrackingNumber = (state, action) =>
    PartRequestForm.update(state, {
        courierInfo: {
            returnTrackingNumber: {
                $set: action.returnTrackingNumber
            }
        }
    });

export default (state = getDefaultState().partRequestForm, action) => {

    const actionHandlers = {
        [actions.RESET_REQUEST_DETAILS]: resetForm,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM]: updatePartRequestForm,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COMMENTS]: updateComments,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COURIER_NAME]: updateCourierName,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_DISPATCH_DATE]: updateDispatchDate,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_RETURN_STATUS]: updateReturnStatus,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_TRACKING_NUMBER]: updateTrackingNumber
    };

    const reducer = actionHandlers[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/reducers/part-request-form.js